import { KampaayDataProvider } from 'services/api/dataProvider'
import { LocationFeature } from 'services/api/entities/catalog/locationFeatures/types/internal/locationFeatures-models'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'

export const locationfeatures: EntityDescriptor<LocationFeature> = {
  format:
    (_dataProvider?: KampaayDataProvider) =>
    ({ id, name, description, image, updatedAt, updatedBy, ...record }) => ({
      id,
      ...parseCsvFields({ name, description }),
      ...record,
    }),
}
